import type { TTableState } from '@/store/table/types'

export const getInitialTablesState = (): { [tableName: string]: TTableState } => {
    return {}
}

const moduleState = getInitialTablesState()

export default moduleState
